import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor() { }

  setSessionData(sessionData: any) {
    console.log('sessionData');
    console.log(sessionData);
    localStorage.setItem('sessionData', JSON.stringify(sessionData));
  }

  getSessionData() {
    const sessionData = localStorage.getItem('sessionData');
    return sessionData ? JSON.parse(sessionData) : null;
  }

  clearSession() {
    console.log('Clearing session data');
    localStorage.removeItem('sessionData');
    console.log('Session data after clearing:', localStorage.getItem('sessionData'));
  }

  isAuthenticated(): boolean {
    console.log('Clearing session data');
    localStorage.removeItem('sessionData');
    console.log('Session data after clearing11111:', this.getSessionData());
    const sessionData = this.getSessionData();
    return !!sessionData && sessionData.user.status === "1";
  }
}
